import Vue from 'vue';

import GlobalSwalModals from './../mixins/GlobalSwalModals'
import GlobalUtilityMethods from './../mixins/GlobalUtility'
Vue.mixin(GlobalUtilityMethods)
Vue.mixin(GlobalSwalModals)

